import {Injectable} from "@angular/core";
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {StockItemCategory} from "../model/stock-item-catgegory.type";
import gql from "graphql-tag";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import {map} from "rxjs/operators";

export const fetchStockItemCategoriesQuery = gql`
      query FetchStockItemCategories {
        stockItemCategories {cuid, label, name}
      }`;

@Injectable()
export class StockItemCategoryService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getStockItemCategories(): ApolloQueryObservable<StockItemCategory[]> {

    let query = this.fetchItems<StockItemCategory[]>({
      query: fetchStockItemCategoriesQuery
    });

    return <ApolloQueryObservable<StockItemCategory[]>>query.pipe(map(({data}:any) => data.stockItemCategories));
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/stock-item-category.service.ts